import React, { useState } from 'react';
import { KatToggle } from '@amzn/katal-react';
import question_icon from 'src/images/icon/question_icon.png';

interface FormSectionProps {
    title: string;
    infoMessage?: string;
    toggleText?: string;
    toggleChecked?: boolean;
    setToggleChecked?: React.Dispatch<React.SetStateAction<boolean>>;
    children: React.ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({ title,
                                                   infoMessage,
                                                   toggleText,
                                                   toggleChecked = false,
                                                   setToggleChecked,
                                                   children }) => {
    const [showInfo, setShowInfo] = useState(false);
    return (
        <div className="section">
            <div className="section-heading">
                {title}
                {infoMessage && (
                    <div
                        style={{ position: 'relative', display: 'inline-block' }}
                        onMouseEnter={() => setShowInfo(true)}
                        onMouseLeave={() => setShowInfo(false)}
                    >
                        <img
                            src={question_icon}
                            alt="Info"
                            className="question-icon"
                        />
                        {showInfo && (
                            <div className="info-message tooltip">
                                {infoMessage}
                            </div>
                        )}
                    </div>
                )}
                {toggleText && (
                    <KatToggle
                        className="toggle"
                        text-checked={toggleText}
                        text-unchecked={toggleText}
                        checked={toggleChecked}
                        onChange={(e: any) => {
                            setToggleChecked && setToggleChecked(e.detail.checked)
                        }}
                    />
                )}
            </div>
            {children}
        </div>
    );
};

export default FormSection;